import { Button, Form, message } from 'ui';
import { useChangePassword } from '../../queries';
import { ChangePasswordFormContent, type ChangePasswordFormContentValues } from '../change-password-form-content';
import { useGetErrorMessage } from '../hooks';

type ChangePasswordFormValues = ChangePasswordFormContentValues;

const ChangePasswordForm = () => {
  const [form] = Form.useForm<ChangePasswordFormValues>();
  const { isPending: isLoading, mutate: changePassword } = useChangePassword();

  const getErrorMessage = useGetErrorMessage();

  const onFinish = (data: ChangePasswordFormValues) => {
    changePassword(data, {
      onError(error) {
        const { duration, errorMessage } = getErrorMessage(error);
        message.error(errorMessage, { duration });
      },
      onSuccess() {
        message.success('Your password was successfully changed');
        form.resetFields();
      },
    });
  };

  return (
    <Form<ChangePasswordFormValues> form={form} onFinish={onFinish}>
      <ChangePasswordFormContent<ChangePasswordFormValues> />
      <Button htmlType="submit" loading={isLoading} size="large" type="primary">
        Change Password
      </Button>
    </Form>
  );
};

export default ChangePasswordForm;
